import { IHistory, IJourney, IWorkFlowStatusInfo, IWorkflowAction, IWorkflowInfo } from './workflow-info.types'

/** class for Workflow info */
export class WorkflowInfo implements IWorkflowInfo {

    Journey: Array<Journey>
    LogStatus: Array<History>
    ActionItems: Array<WorkflowAction>
    CurrentStep: IWorkFlowStatusInfo

    constructor (data: IWorkflowInfo) {    
        this.Journey = data.Journey;
        this.LogStatus = data.LogStatus;
        this.ActionItems = data.ActionItems;
        this.CurrentStep = data.CurrentStep;
    }
}


/** class for Workflow journey */
export class Journey implements IJourney {

    StepId: number
    Status: string
    Action: string
    ChildAction: string
    IsForward: number
    AllowRollback: number

    constructor (data: IJourney) {    
        this.StepId = data.StepId;
        this.Status = data.Status;
        this.Action = data.Action;
        this.ChildAction = data.ChildAction;
        this.IsForward = data.IsForward;
        this.AllowRollback = data.AllowRollback;
    }
}

/** class for Workflow history */
export class History extends Journey implements IHistory {

    WorkflowLogId: number
    LogDate: Date
    Comments: string
    IsCompleted: number
    Username: string

    constructor (data: IHistory) {    
        super(data);
        this.WorkflowLogId = data.WorkflowLogId;
        this.LogDate = data.LogDate;
        this.Comments = data.Comments;
        this.IsCompleted = data.IsCompleted;
        this.Username = data.Username;
    }
}

/** class for workflow action */
export class WorkflowAction extends Journey implements IWorkflowAction {
    Id: number
    AllowSharing: number
    AllowCustomMessage: number
    Recipient: string
    Template: string

    constructor (data: IWorkflowAction) {    
        super(data);
        this.Id = data.Id;
        this.AllowSharing = data.AllowSharing;
        this.AllowCustomMessage = data.AllowCustomMessage;
        this.Recipient = data.Recipient;
        this.Template = data.Template;
    }
}

export class WorkFlowStatusInfo implements IWorkFlowStatusInfo {
    WorkFlowStepId: number
    ParentId: number
    CanPause: number
    InstanceId: number
    Entity: string
    ReturnStatus: number
    ReturnStatusDescription: string   

    constructor (data: IWorkFlowStatusInfo) {   
        this.WorkFlowStepId = data.WorkFlowStepId;
        this.ParentId = data.ParentId;
        this.CanPause = data.CanPause;
        this.InstanceId = data.InstanceId;
        this.Entity = data.Entity;
        this.ReturnStatus = data.ReturnStatus;
        this.ReturnStatusDescription = data.ReturnStatusDescription;
    }
}